import type { PropsWithChildren } from 'react'

import { Stack, type StackProps } from '../stack/stack.tsx'

type FormFieldAdornmentProps = PropsWithChildren & StackProps

const FormFieldAdornment = ({
  children,
  ...props
}: FormFieldAdornmentProps) => (
  <Stack gap="2" {...props}>
    {children}
  </Stack>
)

export { FormFieldAdornment }
